import reducer from './reducer'

import * as piksOperations from './operations'
import * as piksSelectors from './selectors'

export { piksOperations, piksSelectors }

export default reducer
